import { HttpClient } from '@angular/common/http';
import { effect, inject, Injectable, signal, untracked, WritableSignal } from '@angular/core';
import { ClientConfigStore } from '@shared/data';

export interface PublicConfig {
  message: {
    authorizationServerUrl1: string;
    authorizationServerUrl2: string;
    applicationEnvironment: string;
    applicationVersion: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  readonly publicConfigLoaded: WritableSignal<boolean | undefined> = signal(undefined);
  publicConfig = signal<PublicConfig | undefined>(undefined);

  private http = inject(HttpClient);
  private clientConfigStore = inject(ClientConfigStore);

  constructor() {
    effect(() => {
      const clientConfigLoaded = this.clientConfigStore.loaded();
      untracked(() => {
        if (clientConfigLoaded) {
          this.http.get<PublicConfig>('/api/configuration/properties').subscribe({
            next: (value) => {
              this.publicConfig.set(value);
              this.publicConfigLoaded.set(true);
            },
            error: (err) => {
              console.log(`Fehler beim Laden der Konfiguration: ${err.message}`);
              this.publicConfigLoaded.set(false);
            }
          });
        }
      });
    });
  }
}
